import React from 'react';

// Styles & Assets
import styles from './Stop.module.css';
import { IoClose } from 'react-icons/io5';

// Service
import { getAddress, getFullName, getTownNamePatient } from '../../../services/getPatientAtribute';

// Interfaces
import Icon from '../../UI/Icon/Icon';
import { Patient } from '../../../interfaces/Patient';

const Stop: React.FC<{
    patient: Patient,
    index: number,
    handleDeleteStop: (index: number) => void,
}> = ({ patient, index, handleDeleteStop }) => {

    const handleOnClick = () => handleDeleteStop(index);

    return (
        <div className={styles.stopContainer}>
            <button onClick={handleOnClick} className={styles.closeIcon}>
                <Icon><IoClose /></Icon>
            </button>
            <div className={styles.numStopContainer}>
                <p>{index + 1}</p>
            </div>
            {patient && <>
                <div className={styles.infoPatient}>
                    <p className={styles.namePatient}>{getFullName(patient)}</p>
                    <p className={styles.patientData}>{getAddress(patient).split(',', 1)}</p>
                    <p className={styles.patientData}>{getTownNamePatient(patient)}</p>
                    <p className={styles.patientData}>{patient.mobile_phone} - {patient.home_phone}</p>
                </div>
            </>}
        </div>
    );
};

export default Stop;